import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab, Tabs } from "@mui/material";
import { IdmClientContext } from "@sista/idm-client";
import { useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
export const SpratexTabs = ({ canViewRoles }) => {
    const { t } = useTranslation("sprava-textu");
    const view = useParams().view ?? "keys";
    const navigate = useNavigate();
    const { loggedAccount } = useContext(IdmClientContext);
    const switchTabsHandler = useCallback((event, newValue) => {
        return navigate("/" + newValue);
    }, [navigate]);
    return (_jsxs(Tabs, { onChange: switchTabsHandler, value: view, variant: "standard", children: [_jsx(Tab, { label: t("sprava-textu.spratexTabs.keys", "Klíče"), value: "keys" }), _jsx(Tab, { label: t("sprava-textu.spratexTabs.namespaces", "Jmenné prostory"), value: "namespaces" }), _jsx(Tab, { label: t("sprava-textu.spratexTabs.dictionary", "Slovník"), value: "dictionary" }), canViewRoles && (_jsx(Tab, { label: t("sprava-textu.spratexTabs.rolesAdministration", "Správa rolí"), value: "roles" }))] }));
};
